    <template>

        <div>
            <div class="navigation">
                <div class="container">
                    <div class="row"> 
                        <div class="col-xs-12 col-sm-3">
                        </div>               
                        <!--div class="col-xs-12 col-sm-6">
                            <select @change="filterByType(chosenBrewery)" v-model="chosenBrewery" class="form-control brewery-select">
                                <option disabled value="">Select a Brewery</option>
                                <option v-for="(breweries, index) in breweries" :value="breweries.untappedid">{{breweries.name}}</option>
                            </select>
                            <button class="all-brewery-button" v-bind:disabled="!aBarIsChosen" v-on:click.stop="allBreweriesButton()">See All <span class="d-none d-xl-inline">Breweries</span></button>
                        </div-->              
                        <div class="col-xs-12 col-sm-12 col-lg-6">
                            <button class="view-map" v-bind:disabled="mapIsChosen" v-on:click.stop="viewMapButton()">View Map</span></button>
                            <button class="view-list" v-bind:disabled="listIsChosen" v-on:click.stop="viewListButton()">View List</span></button>
                        </div> 
                        <div class="col-xs-12 col-sm-3">
                        </div>                    
                    </div>
                </div>
            </div>          
            <div v-show="!aBarIsChosen" class="brewery"> 
                <div  v-show="mapIsChosen" class="map-section">
                    <div class="map-container">
                        <brewerymap></brewerymap>
                    </div>
                    <div id="map-info" class="map-info-container">
                        <h3 style="margin-top:60px">Choose a Brewery</h3>
                        <p style="padding:0 60px;margin-bottom:60px;">Click one of the markers on the map to view more information on a brewery. If you would rather
                        see a list of breweries, click the "View List" button above.</p>
                    </div>
                </div>
                <div class="container">
                    <div v-show="listIsChosen" class="row card-list">
                        <div class="col-xs-12 col-sm-6 " v-for="(breweries, index) in breweries" v-bind:key="index">

                            <a v-on:click.stop="filterByType(breweries.untappedid)">
                                <div class="card animated flipInX">
                                    <span class="icon">
                                        <img :alt="breweries.name" style="max-width:100px;" :src="'/img/breweryLogos/' + breweries.logo + '-logo.png'" />
                                    </span>
                                    <div class="card-banner" v-bind:style='{ backgroundImage: "url(/img/breweryCardBg/" + breweries.logo + "-cardBg.jpg)"}'>
                                        <div class="shade"></div>
                                        <div class="title">
                                            {{breweries.name}}
                                            <span class="sub-title addy">{{breweries.address}}</span>
                                            <span class="sub-title">{{breweries.city}}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-show="aBarIsChosen">
                <div v-show="loading">

                  <div id="banner"> 
                    <svg version="1.1" id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve">
                      <defs>
                        <clipPath id="drop">
                            <path d="M721.54,317.08s4.92,19.74-4.49,51.64S711,438.37,711,438.37s-27.8,15.73-55.93,0c-.19,0,3.35-37.76-6.06-69.65s-4.42-51.64-4.42-51.64" transform="translate(-641.76 -311.29)" style="stroke:#544129;stroke-miterlimit:10;stroke-width:3px;fill:transparent"/>
                        </clipPath>
                    </defs>

                    <g clip-path="url(#drop)" transform="scale(1,0.90), translate(35,15)">
                        <g class="fill">
                          <path id="waveShape" d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                          c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                          c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z" />
                      </g>
                  </g>

                  <g transform="scale(1.00), translate(35,05)">
                    <path d="M655.24,433.36s-1.51,3.44-.25,5.44c0,0,23.62,18,56,0a5.34,5.34,0,0,0-.25-5.44S682.13,450,655.24,433.36Z" transform="translate(-641.76 -311.29)" style="fill:#f7ba84;stroke:#544129;stroke-miterlimit:10;stroke-width:3px"/>
                    <path d="M721.54,317.08s4.92,19.74-4.49,51.64S711,438.37,711,438.37s-27.8,15.73-55.93,0c-.19,0,3.35-37.76-6.06-69.65s-4.42-51.64-4.42-51.64" transform="translate(-641.76 -311.29)" style="stroke:#544129;stroke-miterlimit:10;stroke-width:3px;fill:transparent"/>
                    <ellipse cx="41.4" cy="6.15" rx="38.39" ry="4.65" style="fill:transparent;stroke:#544129;stroke-miterlimit:10;stroke-width:3px"/>
                </g>
            </svg>
        </div>
    </div>

    <div class="animated fadeIn" v-show="!loading">
        <div class="brewery-banner">
            <img :alt="chosenBar.name" class="d-none d-lg-block d-xl-block" v-bind:src="'/img/breweryBanners/' + chosenBar.logo + '-banner.jpg'">
            <img :alt="chosenBar.name" class="d-none d-md-block d-lg-none" v-bind:src="'/img/breweryBanners/' + chosenBar.logo + '-banner-md.jpg'" alt="photo from chosenBar.Logo">
            <img :alt="chosenBar.name" class="d-block d-sm-none" v-bind:src="'/img/breweryBanners/' + chosenBar.logo + '-banner-sm.jpg'" alt="photo from chosenBar.Logo">
        </div>
        <div class="container brewery-details">
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <h1>
                        {{ chosenBar.name }}
                    </h1>
                    <h3 class="subhead">
                        Brewery Profile
                    </h3>
                    <p>
                        {{chosenBar.sppgdescription}}
                    </p>
                    <div class="brewery-quote">
                        <p>
                            <strong>How the brewery describes itself:</strong> "<em>{{chosenBar.description}}</em>"
                        </p>
                    </div>
                </div>

                <div class="col-md-12  col-lg-6">
                    <div class="brewery-summary">
                        <h2>Explore the Brewery</h2>
                        <div class="summary">
                            <span class="brewery-label">
                                <a :href="'http://www.' + chosenBar.website" target="_blank">
                                    <img :alt="chosenBar.name" v-bind:src="'/img/breweryLogos/' + chosenBar.logo + '-logo.png'" />
                                </a>
                            </span>

                            <span class="brewery">{{chosenBar.name}}</span>
                            <span class="addy">{{chosenBar.address}}</span>
                            <div class="social-links">
                                <a v-if="hasFacebook"  :href="'http://www.facebook.com/' + chosenBar.facebook" target="_blank">
                                    <img alt="brewery Facebook link" class="soc-icon" src="/img/facebook.svg" />
                                </a>
                                <a v-if="hasInstagram" :href="'http://www.instagram.com/' + chosenBar.instagram" target="_blank">
                                    <img alt="brewery Instagram link" class="soc-icon" src="/img/instagram.svg" />
                                </a>
                                <a v-if="hasTwitter" :href="'http://www.twitter.com/' + chosenBar.twitter" target="_blank">
                                    <img alt="brewery Twitter link" class="soc-icon" src="/img/twitter.svg" />
                                </a>
                                <a v-if="hasWebsite"  :href="'http://www.' + chosenBar.website" target="_blank">
                                    <img alt="brewery website link" class="soc-icon" src="/img/web.svg" />
                                </a>
                                <a :href="'tel:' + chosenBar.phone">
                                    <img alt="brewery phone link" class="soc-icon" src="/img/sppgphone.svg" />
                                </a>
                            </div>
                            <div class="clearfix"></div>
                            <div class="iframe-container">
                                <iframe :src="chosenBar.googlemap" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <section v-if="photos" class="gallery-section ss-style-doublediagonal">
            <h3 class="centered gallery-head">Take A Look Around</h3>
            <div class="gallery">

                <slick ref="slick" :options="slickOptions">
                    <div v-for="(n, index) in photos">
                        <img v-bind:src="'/img/photos/' + chosenBar.logo + '/' + n + '.jpg'" />
                    </div>
                    
                </slick>

            </div>
        </section>

        <section class="beer-list">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#all"><h3 class="text-center tab-h3"> All Beers on Tap</h3></a>
                </li>           
                <li class="nav-item reviewed-beers-tab">
                    <a class="nav-link" data-toggle="tab" href="#had"><h3 class="text-center tab-h3">Beers We've <br class="d-block d-sm-none" />Had</h3></a>
                </li>
            </ul>

            <div class="tab-content">
                <div class="tab-pane container active" id="all">
                    <beers :stringProp="chosenBar.untappedid"></beers>
                </div>
                <div class="tab-pane container" id="had">
                    <reviewedbeers :nameProp="chosenBar.name"></reviewedbeers>
                </div>
            </div>
        </section>
        <section class="comment-section">
            <div class="row">
                <div class="container">
                    <div class="comments">
                        <vue-disqus shortname="stpetepintguide" :identifier="chosenBar.name" url="http://stpetepintguide.com/"></vue-disqus>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<div>
    <contact></contact>
</div>
</div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import Vue from 'vue';
import VueDisqus from 'vue-disqus';
Vue.use(VueDisqus);
import Slick from 'vue-slick';
import BeerDash from '@/components/BeerDash.vue';
import BreweryMap from '@/components/BreweryMap.vue';
import ReviewedBeerDash from '@/components/ReviewedBeerDash.vue';
import PhotoDash from '@/components/PhotoDash.vue';
import Contact from '@/components/Contact.vue';
import { EventBus } from '@/utils/event-bus.js';
import firebase from 'firebase/app';
import 'firebase/database';


        // firebase init goes here
        const config = {
            apiKey: "AIzaSyA33rRQ3rlgUatJpEGBwI8ncTA9nwTnYI8",
            authDomain: "pint-guide-vue-app.firebaseapp.com",
            databaseURL: "https://pint-guide-vue-app.firebaseio.com",
            projectId: "pint-guide-vue-app",
            storageBucket: "pint-guide-vue-app.appspot.com",
            messagingSenderId: "732925644435",
            appId: "1:732925644435:web:2a22602c2083ce7f960766",
            measurementId: "G-RB7H3VM2MR"
        }
        let app = firebase.initializeApp(config);
        let db = app.database();
        let breweriesRef = db.ref("breweries");
        var cachedBreweries = [];
        var breweries = [];
        var chosenBar = [];
        var photos = [];
        var aBarIsChosen = false;
        var mapIsChosen = true;
        var listIsChosen = false;
        var hasWebsite = false;
        var hasFacebook = false;
        var hasTwitter = false;
        var hasInstagram = false;
        var loading = true;
        var chosenBrewery = '';

        export default {
            name: 'BreweryDrop',

            data() {
                return {
                    breweries: [], slickOptions: {
                        arrows: false,
                        dots: false,
                        infinite: true,
                        slidesToShow: 3,
                        autoplay: true,
                        autoplaySpeed: 8000,
                        responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,

                            }
                        },]
                //slidesToScroll: 3
                // Any other options that can be got from plugin documentation
            },cachedBreweries: [], photos: [], chosenBrewery, chosenBar, aBarIsChosen, hasFacebook, hasWebsite, hasTwitter, hasInstagram, mapIsChosen, listIsChosen, loading
        }
    },
    components: {
        Slick ,
        'beers': BeerDash,
        'reviewedbeers': ReviewedBeerDash,
        //'twitterfeed': BreweryTwitter,
        'photos': PhotoDash,
        'brewerymap':BreweryMap,
        'contact': Contact
    },
    created() {
        db.ref("breweries")
        .once("value")
        .then(dataSnapshot => {
            const itemsArray = [];
            dataSnapshot.forEach(childSnapshot => {
                const childData = childSnapshot.val();
                itemsArray.push({
                    address: childData.Address,
                    city: childData.City,
                    description: childData.Description,
                    facebook: childData.Facebook,
                    googlemap: childData.GoogleMap,
                    instagram: childData.Instagram,
                    logo: childData.Logo,
                    name: childData.Name,
                    photos: childData.Photos,
                    phone: childData.Phone,
                    sppgdescription: childData.SppgDescription,
                    twitter: childData.Twitter,
                    untappedid: childData.UntappedId,
                    website: childData.Website,
                    zip: childData.Zip                
                });
            });
            this.cachedBreweries = itemsArray;
            this.breweries = this.cachedBreweries;
            this.chosenBar = this.breweries[0];     
        });

        // Listen for the i-got-clicked event and its payload.
        EventBus.$on('map-marker-click', chosenBar => {
            const vm = this;
            vm.filterByType(chosenBar);
        });
    },
    methods: {
        resetWindow() {
            this.breweries = this.cachedBreweries;
            this.aBarIsChosen = false;
            this.loading = true;      
            this.chosenBar = "";
            this.chosenBrewery = "";

        },
        beforeUpdate() {
            if (this.$refs.slick) {
                this.$refs.slick.destroy();
            }
        },
        updated() {
            this.$nextTick(function () {
                if (this.$refs.slick) {
                    this.$refs.slick.create(this.slickOptions);
                }
            });
        },
        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        disqusSet(sortKey) {
            DISQUS.reset({
                reload: true,
                config: function () {  
                    this.page.identifier = sortKey;  
                    this.page.url = "http://stpetepintguide.com/#!" + sortKey;
                }
            });
        },
        allBreweriesButton() {
            this.resetWindow();           
        },   
        viewMapButton() {
            this.resetWindow();  
            this.mapIsChosen = true;  
            this.listIsChosen = false;         
        }, 
        viewListButton() {
            this.resetWindow(); 
            this.listIsChosen = true;    
            this.mapIsChosen = false;             
        },       
        filterByType(sortKey) {
            this.resetWindow();
            this.beforeUpdate();
            
            for (var i = 0, iLen = this.breweries.length; i < iLen; i++) {
                if (this.breweries[i].untappedid == sortKey) {
                    this.chosenBar = this.breweries[i];
                    this.aBarIsChosen = true;
                    this.mapIsChosen = false;
                    this.listIsChosen = false;
                    this.loading = false;
                    this.chosenBrewery = sortKey;
                    this.disqusSet(sortKey);
                    this.photos = this.breweries[i].photos;

                    this.hasFacebook = false;
                    this.hasWebsite = false;
                    this.hasInstagram = false;
                    this.hasTwitter = false;

                    console.log(this.breweries[i].website);
                    if(this.breweries[i].website !== "none"){
                        this.hasWebsite = true;
                    }
                    if(this.breweries[i].facebook !== "none"){
                        this.hasFacebook = true; 
                    }
                    if(this.breweries[i].twitter !== "none"){
                        this.hasTwitter = true;    
                    }

                    if(this.breweries[i].instagram !== "none"){
                        this.hasInstagram = true;    
                    }
                    this.updated();
                    var target = $('#app');
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: target.offset().top
                        }, 0);
                        return false;
                    }
                }
            }
            
        }
    }
}
</script>

<style lang="less" src="@/assets/styles/components/brewery-dash.less">
</style>
<style lang="less" src="@/assets/styles/components/contact-form.less">
</style>
<style lang="less" src="@/assets/styles/components/slick.less">
</style>
<style lang="css" src="@/assets/styles/components/animate.css">
</style>
